import { BaseDataGridRequest } from "../base-data-grid.request";

export interface GetMasterPlansRequest extends BaseDataGridRequest {
  searchparams? : string;
  }
  